/**
 * @generated SignedSource<<08ae39f7c6d8d3adf4a8ec4699524c84>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type topicCardFragment$data = {
  readonly items: ReadonlyArray<{
    readonly __id: string;
    readonly displayLink: string | null | undefined;
    readonly entityKey: string | null | undefined;
    readonly helpObjectType: string | null | undefined;
    readonly logo: string | null | undefined;
    readonly title: string | null | undefined;
  }> | null | undefined;
  readonly topicId: string | null | undefined;
  readonly topicName: string | null | undefined;
  readonly " $fragmentType": "topicCardFragment";
};
export type topicCardFragment$key = {
  readonly " $data"?: topicCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "topicCardFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "topicName"
    },
    {
      "kind": "ScalarField",
      "name": "topicId"
    },
    {
      "concreteType": "HelpLayoutTopicItem",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "title"
        },
        {
          "kind": "ScalarField",
          "name": "logo"
        },
        {
          "kind": "ScalarField",
          "name": "displayLink"
        },
        {
          "kind": "ScalarField",
          "name": "entityKey"
        },
        {
          "kind": "ScalarField",
          "name": "helpObjectType"
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__id"
            }
          ]
        }
      ]
    }
  ],
  "type": "HelpLayoutTopic"
};

(node as any).hash = "a170162f291e4b6022384af02ae41de2";

export default node;
